import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { TrialOrgInfo } from '../../models/trialOrgInfo';
import { ITrialService } from '../../services/Trial/trial.service.interface';

@Component({
  selector: 'pinnacle-trial-confirmation',
  templateUrl: './pinnacle-trial-confirmation.component.html',
  styleUrls: ['./pinnacle-trial-confirmation.component.scss']
})
export class PinnacleTrialConfirmationComponent implements OnInit, AfterViewInit {

  @ViewChild('formButton', { read: ElementRef, static: true }) formButton: ElementRef;
  orgData: TrialOrgInfo;
  trialService: ITrialService;

  constructor(trialService: ITrialService) { 
    this.trialService = trialService;
  }

  ngOnInit() {
    this.orgData = JSON.parse(localStorage.getItem("trialOrgInfo"));

    this.trialService.submitHubspotPinnacleForm(this.orgData).subscribe(hubspot => {
    });

  }

  ngAfterViewInit() {
    //submit a fake form for google tag manager tracking
    if (this.orgData && this.orgData.firstName) {
      this.formButton.nativeElement.click();
    }
    
  }

  onSubmit() {
    console.log("submitted!");
    localStorage.clear();
  }
}
